<template>
    
	<div class="ml-1 mt-3 row general-border mr-1">
        <div class="column col-12 lesson-border">
            <div class="row ml-2 mb-0 mt-1 mr-2">
                <h4>Lessons</h4>
                <div v-if="!generic_module_view" class="put_content_right">
                    <button v-if="lesson_edit" class="button-sme mb-0" @click="lesson_edit = !lesson_edit">
                        <img width="15" src="../../../assets/images/icons/solid/edit.svg" />
                    </button>
                    <button v-if="!lesson_edit" class="button mb-0" @click="saveModule">
                      SAVE
                    </button>
                </div>
            </div>

            <div v-for="(lesson, index) in lesson_list" :key="lesson.order" class="row ml-1 mr-1 mb-3 lesson-border white-background">
               
                <div class="col mt-1  ml-1">
                    <span class="lesson-order-frame">{{index + 1}}</span>
                   <div v-if="lesson.image[selected_language.key] == null" class="image-holder-empty dropzone-module-small">
                       <lesson-drop-zone 
                       @updateLessonTincan="updateLessonTincan"
                       :temp_url_tincan="getLessonURLTican(lesson.id)"
                       :selected_language="selected_language"
                        :lesson="lesson" :key="lesson.id"
                        :index="index"/>
                   </div>
                    
                     <div v-else class="image-holder dropzone-module-small">
                     <img class="dropzone-module-small" :src="lesson.image[selected_language.key] + '?v=' + Date.now()"/>
                    

                     </div>
                        <div class="mt-2 ml-2" v-if="lesson.has_tincan[selected_language.key]">
                            <lesson-file-view :tincan="false" :current_lesson="lesson" 
                            :selected_language="selected_language"
                             @openRemoveTincanModal="openRemoveTincanModal"
                            ></lesson-file-view>

                            <lesson-tincan-dropdown :file_types="file_types" :lesson="lesson" :key="lesson.id"/>

                        </div>
                    </div>

                    <div class="col">
                        <div class="row">
                        <div class="put_content_right mr-3">
                        <button @click="open_lesson(index)" class="button-sme mb-0 mt-1">
                            <img width="15" src="../../../assets/images/icons/solid/external-link-alt.svg" />
                        </button>
                    </div>

                    </div>

                    <div class="input-content mt-2">
                         <!-- <input class="input-course-title desciption-width" placeholder="Lesson Name here..." v-model="lesson.name" v-validate="'required'" name="name"/>
                        <span class="input-error-msg">{{ errors.first('name') }}</span> -->
                        <textarea
                            :class="{'ml-2 input-lesson-title lesson_title desciption-width' : wider_view, 'min-width-200  input-lesson-title lesson_title': !wider_view}"
                            :readonly="lesson_edit"
                            placeholder="Lesson Name here..."
                            v-model="lesson.name[selected_language.key]"
                            v-validate="''"
                            :name="`Lesson ${lesson.id} name`"
                            @input="nameChange(lesson.name[selected_language.key], lesson.id)"
                        />
                            <div v-if="generic_module_view" class="put_content_right mt-1">
                                         {{lesson.created_at}}
                                        <img class="ml-5" width="15" src="../../../assets/images/icons/solid/clock.svg" />
                                      {{Math.round(lesson.duration_int/60)}}
                                      
                                     
                    

                            </div>
                        <div v-if="!generic_module_view" class="column desciption-width col-12 mt-3">
                            <textarea :readonly="lesson_edit" class="form-control mb-2 deneme" v-model="lesson.description"
                            v-validate="" 
                            placeholder="Lesson Objectives"
                            name="description"
                                ></textarea>
                                <div class="put_content_right">
                                       03/01/2021 12:21{{lesson.created_at}}
                                        <img class="ml-5" width="15" src="../../../assets/images/icons/solid/clock.svg" />
                                     1:30{{lesson.duration}}

                                </div>
                        </div>
                    
                    </div>
                </div>
                    <!-- <vue-dropzone v-if="!generic_module_view" class="dropzone-module-small" ref="tincanDropzone" id="dropzone" 
                    :options="dropzoneOptions"
                    @vdropzone-success="attachmentUploaded">
                    </vue-dropzone> -->

      
            </div>
            <div v-if="current_module.has_module_quiz" class="row ml-1 mr-1 mb-3 lesson-border white-background">
                <div class="col mt-1  ml-1">
                    <span class="lesson-order-frame">{{lesson_list.length+1}}</span>

                    <div class="input-content mt-2">
                        <div class="input-lesson-title">Quiz</div>
                        
                    </div>
                </div>
            </div>
            
        </div>   
 <div v-if="this.curren_lesson_show != null">
        <b-modal id="modal-multi-1" size="xl" v-model="modalShow" no-close-on-esc no-close-on-backdrop no-stacking hide-header
        ok-title="Publish" cancel-title="Close"
        @cancel="resetModal" @ok="publishLesson">
        <b-container fluid>
            <div class="row put_content_right">
                 <h4>{{current_lesson_modal.name[selected_language.key]}}</h4>
                <button class="button put_content_right" @click="lessonSave">Save</button>
            </div>
           
            <b-row class="mb-1">
                <b-col sm="4">
                    <div class="row ml-0">
                        <h6>ID <b>{{current_lesson_modal.id}}</b> <img class="ml-5" width="15" src="../../../assets/images/icons/solid/clock.svg" />
                        <input
                            class="edit-time"
                            v-validate="'required|numeric|min_value:1'"
                            name="Lesson duration"
                            v-model="current_lesson_duration_minutes"
                        >
                        min
                        <input class="ml-2" type="checkbox" @change="quizPropertyChange" v-model="temp_quiz">
                        <b>Quiz</b></h6>
                    </div>

                    <div v-if="errors.first('Lesson duration')" class="input-content">
                        <span class="input-error-msg">{{ errors.first('Lesson duration') }}</span>
                    </div>

                    <h6 class="mt-2">Notes</h6>
                            <textarea class="form-control mb-2 height-180" 
                            v-model="current_lesson_modal.notes"
                            v-validate="''"
                            placeholder="Lesson Notes"
                            name="description"></textarea>
                    <div class="row">
                        <div class="col col-6">
                            <span><h6>Date Created</h6></span>
                            <span><p> {{current_lesson_modal.created_at}}</p></span>
                        </div>
                        <div class="col col-6">
                            <span><h6>Date Modified</h6></span>
                            <span><p> {{current_lesson_modal.updated_at}}</p></span>
                        </div>
                    </div>
                   
               </b-col>
              
                <b-col>
                    <b-tabs v-model="tabIndex" class="column col-12">
                        <b-tab class="white-background" :key="index" v-for="(language, index) in module_available_languages" @click="change_language(language)" :title="language.value">
                            <b-container class="mb-3 mt-2" fluid>
                                <b-row>
                                     <b-col>
                                        <div v-if="current_lesson_modal.has_tincan[language.key]" class="image-holder dropzone-module-small">
                                        <img class="dropzone-module-small" :src="current_lesson_modal.image[language.key]" />
                                        </div>
                                        <vue-dropzone v-else class="dropzone-module-small w-25" ref="tincanDropzone" id="dropzone_lesson_list" :key="`${language}`"
                                        :options="dropzoneOptions"
                                        :url="dropzoneOptions.url"
                                        @vdropzone-error="dropzoneFail"
                                        @vdropzone-success="attachmentUploaded">
                                        </vue-dropzone>

                                        <v-select name="File Type" placeholder="Select File Type" v-model="lesson_file_type" :options="file_types" :disabled="!current_lesson_has_tincan" class="width-90 mt-1"
                                         label="filetype" :class="{ 'input-disabled' : !current_lesson_has_tincan  }"
                                               v-validate="file_type_rules">
                                        </v-select>
                                        
                                        <div v-if="errors.first('File Type')" class="input-content">
                                            <span class="input-error-msg">{{ errors.first('File Type') }}</span>
                                        </div>
                                        
                                        <h6>
                                            <input class="my-3 mr-1" type="checkbox" v-model="vertical_fullscreen_val">
                                            <b>Portrait Full Screen</b>
                                        </h6>
                                        
                                        <div class="mt-2" v-if="current_lesson_modal.has_tincan[language.key] && !has_to_select_file_type">
                                           <lesson-file-view  :tincan="current_lesson_modal.has_tincan[language.key]" :current_lesson="current_lesson_modal"
                                           :selected_language="language"
                                           
                                           @openRemoveTincanModal="openRemoveTincanModal"
                                           ></lesson-file-view>
                                          
                                        </div>
                                      
                                     </b-col>
                                     <b-col>
                                   <div class="input-content">
                                        <textarea
                                            class="ml-1 input-lesson-title lesson_title_tall"
                                            :readonly="lesson_edit"
                                            placeholder="Lesson Name here..."
                                            v-model="current_lesson_modal.name[language.key]"
                                            v-validate="''"
                                            name="Lesson name"
                                        />

                                        <div v-if="errors.first('Lesson name')" class="input-content">
                                            <span class="input-error-msg">{{ errors.first('Lesson name') }}</span>
                                        </div>


                                   <!-- <input class="input-course-title" placeholder="Module Name here..." v-model="current_lesson_modal.name" v-validate="'required'" name="name"/> -->
                                   </div>
                                     </b-col>
                                </b-row>
                              
                                </b-container>
                                
                            <b-container fluid>
                         
                                 <textarea
                                    class="form-control mb-2 deneme mt-4"
                                    v-model="current_lesson_modal.description[language.key]"
                                    v-validate="''"
                                    placeholder="Lesson Objectives"
                                    name="Lesson objectives"
                                ></textarea>
                            </b-container>

                            <div v-if="errors.first('Lesson objectives')" class="input-content">
                                <span class="input-error-msg">{{ errors.first('Lesson objectives') }}</span>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-col>
                
            </b-row>
        </b-container>
    </b-modal>
    </div>  
    <div v-if="modal_lesson != null">
       <b-modal id="modal-multi-2" v-model="show_modal_delete_tincan" no-close-on-esc no-close-on-backdrop title="Delete Tincan" @ok="removeTincan"  @close="closeModal" cancel-title="No" ok-title="Yes">

            <p v-if="modal_lesson.is_clone || modal_lesson.is_master" class="mb-2">
                You are about to change media for <b>{{modal_lesson.relations_count}} lesson<span v-if="modal_lesson.relations_count>1">s</span></b>! Are you sure?
            </p>
            <p v-else class="mb-2">
                Are you sure you want to delete the Tincan <b>{{ modal_lesson_name_key() }}?</b>
            </p>
           
		</b-modal> 
    </div>
    <div v-if="modal_pair_warning">
       <b-modal id="modal-multi-2" v-model="modal_pair_warning" no-close-on-esc no-close-on-backdrop title="Modal Relations" @ok="modalPairQuizCont(false)"  @cancel="modalPairQuizCancel(true) " cancel-title="Cance" ok-title="Continue">
            <p class="mb-2">
               Removing quiz from lesson will affect the base module relationship.
            </p>
		</b-modal> 
    </div>
    <div v-if="modal_pair_warning_quiz">
       <b-modal id="modal-multi-2" v-model="modal_pair_warning_quiz" no-close-on-esc no-close-on-backdrop title="Modal Relations" @ok="modalPairQuizCont(true)"  @cancel="modalPairQuizCancel(false)" cancel-title="Cancel" ok-title="Continue">
            <p class="mb-2">
               This Module has Quiz Module Relation, adding quiz to lesson will affect the quiz module relationship.
            </p>
		</b-modal> 
    </div>
    </div>
</template>
<script>
import PictureInput from 'vue-picture-input';
import LessonFileView from '../SharedViews/LessonFileView'
import LessonDropZone from '../SharedViews/LessonDropZone'
import LessonTincanDropdown from '../SharedViews/LessonTincanDropdown'
import { EventBus } from './../../../event_bus.js';
export default{
    props:[
        'course_data', 'current_module','lessons', 'generic_module_view',
        'wider_view','selected_language','module_available_languages','current_tab'
    ],
    components: {
		PictureInput, LessonFileView,LessonDropZone,LessonTincanDropdown
	},
    inject: ['$validator'],
    computed : {
   
        file_type_rules:function(){
            if(this.current_lesson_has_tincan){
                return `required`;
            }
            if(this.current_lesson_modal.has_tincan[this.temp_language.key] && this.lesson_file_type == ''){
                return `required`;
            }
        },
        current_lesson_modal: function(){
            if(this.curren_lesson_show != null){
                this.lesson_file_type = this.curren_lesson_show.filetype
            }
            return this.curren_lesson_show
        },
        new_lesson: function(){
            if(this.current_lesson_modal.attachments == undefined){
                return true
            }
        },
        current_lesson_has_tincan: function(){
            let status = false
            if(this.current_lesson_modal.has_tincan[this.temp_language.key]){
                status  = true
            }
            return status
        },
        hasLessonVideo() {
            if (!this.lesson_list) return {};
            return this.lesson_list.reduce((acc, lesson) => {
                acc[lesson.id] = !!lesson.has_tincan[this.selected_language.key];
                return acc;
            }, {});
            // return !!lesson.has_tincan[selected_language.key];
        },
        hasLessonName() {
            if (!this.lesson_list) return {};
            return this.lesson_list.reduce((acc, lesson) => {
                acc[lesson.id] = !!lesson.name[this.selected_language.key];
                return acc;
            }, {});
            // return !!lesson.name[selected_language.key];
        },
    },
    data : function(){
        return{
            tabIndex:0,
            modalShow: false,
            modal_lesson:null,
            show_modal_delete_tincan:false,
            description:'Some explanation here',
            notes:'Some notes here',
            lesson_edit:false,
            temp_url_tincan: this.config.UPLOAD_TINCAN_FILE,
            dropzoneOptions: {
                url : this.temp_url_tincan,
                thumbnailWidth: 50,
                maxFilesize: 500,
                maxFiles : 1,
                timeout : 300000,
                addRemoveLinks : true,
                headers : {
                    'Autrollization' : localStorage.getItem('token')
                }
            },
            curren_lesson_show:null,
            lesson_list: this.lessons,
            current_lesson_duration_minutes:'',
            temp_language:'',
            current_lesson_delete_id:'',
            temp_lesson_title: 'Lesson created! Click me to edit',
            lesson_open_event_index:'',
            modal_pair_warning:false,
            modal_pair_warning_quiz:false,
            temp_quiz:'',
            vertical_fullscreen_val: '',
            lesson_file_type:'',
            file_types:['Tincan','Rise'],
            has_to_select_file_type:false
        }
    },
    watch:{
        lesson_list: function(){
            this.lesson_list = this.checkLessonLanguages(this.selected_language, this.lesson_list)

        },
        selected_language: function(val){
            this.lesson_list = this.checkLessonLanguages(val, this.lesson_list)
        },
        lessons: function(val){
            this.lesson_list = val
        },
       'current_lesson_modal.duration_int': function(val){
           if(val == null){ 
               this.current_lesson_duration_minutes = 0
               return
           }
           this.current_lesson_duration_minutes =  Math.round(parseInt(val) / 60)
        },
        'current_lesson_modal.has_quiz': function(val){
            if(val == 1 || val == true){
                //update current module course
                EventBus.$emit('updateModuleQuiz', val)

            }
            if(val ==0 || val == false){
                //uncheck current module course
                EventBus.$emit('updateModuleQuiz', val)
            }
            this.temp_quiz = val
        },
        'current_lesson_modal.vertical_fullscreen': function(val){
            this.vertical_fullscreen_val = val
        }
    },
    mounted: function(){
        if(this.selected_language != null){
            EventBus.$on('openLesson2', (index) => {
            this.lesson_open_event_index = index
				this.open_lesson(index)
                return
			});
        }
        EventBus.$on('update_program_lesson', (new_lesson) => {
                 this.$nextTick(() => {
                     this.lesson_list = new_lesson.lessons
                });
            
        })
    },
    created : function(){
        this.getFileTypes();
        this.lesson_list = this.checkLessonLanguages(this.selected_language,this.lesson_list)

    },
    methods:{
        nameChange: function(name, id){
            this.$emit('updateLessonName', name, id)
        },
        getLessonURLTican: function(id){
            var temp_tincan = this.config.UPLOAD_TINCAN_FILE
            return temp_tincan.replace('%LESSON_ID%',id)
        },
        modal_lesson_name_key: function(){
            if(this.current_lesson_modal == null){
                return this.modal_lesson.name[this.selected_language.key]
            }else{
                return this.modal_lesson.name[this.temp_language.key]
            }
        },
        getFileTypes: function(){
            var params = {}
            this.$store.dispatch('getFileTypes', params).then((res) => {
                this.file_types = res.data
            }).catch((error) => {
                console.log(error);
            });
        },
        modalPairQuizCont: function(val){
            this.lessonSave();
            this.modalShow = true
        },
        modalPairQuizCancel:function(val){
            // if(val){
            //     this.current_lesson_modal.has_quiz = true
            // }else{
            //     this.current_lesson_modal.has_quiz = false
            // }
            this.temp_quiz = this.current_lesson_modal.has_quiz
            this.modalShow = true
        },
        quizPropertyChange: function(){
             //open modal to let user know what they are doing
            if((!!this.current_module.base_module_id)&& this.current_lesson_modal.has_quiz == 1){
                this.modal_pair_warning = !this.modal_pair_warning
            }
            if((!!this.current_module.quiz_module_id)&& this.current_lesson_modal.has_quiz == 0){
                this.modal_pair_warning_quiz = !this.modal_pair_warning_quiz
            }
        },
        findLessonIndex:function(lesson_to_find){
            var lesson_index = null
            this.lesson_list.filter((elem, index)=>{
                 if(elem.id == lesson_to_find.id){
                     console.log(index)
                     lesson_index = index
                 }
              })
            return lesson_index
        },
        change_language: function(val){
            this.setTincan(val)
            this.$nextTick(() => {
                    this.$forceUpdate(); 
                });
        },
        checkLessonLanguages: function(val,lesson_list){
            if(lesson_list == undefined){ return; }
            if(lesson_list.length == 0){ return; }

           for(let i in lesson_list){
            if(lesson_list[i].name == null){
                lesson_list[i].name = {}
            } 
            if(!lesson_list[i].name.hasOwnProperty(val.key)){
                lesson_list[i].name[val.key] = ''
            }
            if(lesson_list[i].image == null){
                lesson_list[i].image = {}
            }
            if(lesson_list[i].tincan_url == null){
                lesson_list[i].tincan_url = {}
            }
            if(lesson_list[i].tincan_thumbnail == null){
                lesson_list[i].tincan_thumbnail = {}
            }
            if(lesson_list[i].tincan_download_url == null){
                lesson_list[i].tincan_download_url = {}
            }
            if(!lesson_list[i].image.hasOwnProperty(val.key)){
                lesson_list[i].image[val.key] = null
            }
           }
           return lesson_list
        },
        setTincan:function(language){
            if(language == undefined || language == null){
                language = this.selected_language
                this.temp_language = this.selected_language
            }
            this.temp_language = language
            this.temp_url_tincan = this.config.UPLOAD_TINCAN_FILE.replace('%LESSON_ID%',this.curren_lesson_show.id)
            this.dropzoneOptions.url = this.temp_url_tincan+'/'+this.temp_language.key
            if(this.$refs.tincanDropzone){
                for(let i in this.$refs.tincanDropzone){
                    this.$refs.tincanDropzone[i].dropzone.options.url =  this.dropzoneOptions.url
                }
            }
            

        },
        closeModal:function(){
            this.curren_lesson_show = null
            this.modal_lesson = null
            this.show_modal_delete_tincan = false
            this.temp_language = ''
            

        },
        openRemoveTincanModal: function(current_lesson){
            this.modal_lesson = current_lesson
            this.show_modal_delete_tincan = true
        },
        onChange : function(){
            this.$emit('onChange',course_data.image)

        },
        attachmentUploaded : function(file, response){
            //when we come here, make the v-select mandatory
            this.lesson_file_type = ''
            //here lets refresh the lessons
            this.current_lesson_modal.has_tincan[this.temp_language.key] = true
            this.current_lesson_modal.image[this.temp_language.key] = response.lesson.image[this.temp_language.key]
            this.current_lesson_modal.tincan_thumbnail[this.temp_language.key] = response.lesson.tincan_thumbnail[this.temp_language.key]
            this.current_lesson_modal.tincan_url[this.temp_language.key] = response.lesson.tincan_url[this.temp_language.key]        
            this.current_lesson_modal.tincan_download_url[this.temp_language.key] = response.lesson.tincan_download_url[this.temp_language.key]   
            
        },
        openAdd: function(){
        },
        open_lesson: function(index){
            if(this.lesson_list[index].description == null){
                this.lesson_list[index].description={}
                this.lesson_list[index].description[this.selected_language.key] = ''

            }
            this.checkLessonLanguages(this.selected_language, this.lesson_list)
            this.curren_lesson_show = this.lesson_list[index]

            this.setTincan(this.selected_language)
            this.modalShow = !this.modalShow
            this.$nextTick(() => {
                this.$forceUpdate(); 
                this.tabIndex = this.current_tab-1
                
              });
           
        },
        resetModal: function(){
            this.curren_lesson_show = null
            this.modalShow = !this.modalShow
            this.temp_language = ''
        },
        lessonSave: function(){
            this.$validator.validateAll().then((result)=>{
                if(result){
                    //find lesson id
                    
                    if(this.current_lesson_has_tincan &&( this.lesson_filetype !=  null || this.lesson_filetype != '' )){
                        this.current_lesson_modal.lesson_filetype_id = this.lesson_file_type.id
                    }else{
                        delete this.current_lesson_modal.lesson_filetype_id
                        delete this.current_lesson_modal.filetype
                    }
                    this.current_lesson_modal.vertical_fullscreen = this.vertical_fullscreen_val
                    this.current_lesson_modal.has_quiz = this.temp_quiz
                    let index = this.findLessonIndex(this.current_lesson_modal)
                     this.current_lesson_modal.duration_int = (this.current_lesson_duration_minutes *60)
                     if(this.current_lesson_modal.title = this.temp_lesson_title){
                            if('EN' in this.current_lesson_modal.name){
                                this.current_lesson_modal.title = this.current_lesson_modal.name['EN']
                            }
                     }
                     this.$store.dispatch('editLesson', this.current_lesson_modal).then((res) => {
                         this.current_lesson_modal.has_quiz = res.data.lesson.has_quiz
                         this.$nextTick(() => {
                           this.lesson_list[index].filetype = res.data.lesson.filetype
                           this.lesson_list[index].image = res.data.lesson.image
                           this.lesson_list[index].name = res.data.lesson.name
                           this.lesson_list[index].tincan_thumbnail = res.data.lesson.tincan_thumbnail
                           this.lesson_list[index].tincan_url = res.data.lesson.tincan_url
                           this.$forceUpdate();

                        })

                    }).catch((error) => {
                        this.$snotify.error('Error from server');
                    });

                }
            })
           
        },
        publishLesson: function(evt){
            evt.preventDefault()
            this.$validator.validateAll().then((result)=>{
                if(result){
                    this.lessonSave();
                    this.modalShow = !this.modalShow
                }
            })
            
        },
        saveModule: function(){
            this.$emit('saveModule')
            this.lesson_edit = !this.lesson_edit
        },
        removeAttachment : function(attachment_id, current_lesson){
            var params = { id : current_lesson.id, attachment_id : attachment_id };
            
            this.$store.dispatch('removeAttachment', params).then((res) => {
                this.current_lesson.attachments = res.data.lesson.attachments;
            }).catch((error) => {
                console.log(error);
            });
        },
        removeTincan : function(){
            var lesson_index = ''
            if(this.current_lesson_modal != null){
                this.lesson_list.forEach((elem, index)=>{
                        if(elem.id == this.current_lesson_modal.id){
                            lesson_index = index
                            this.current_lesson_delete_id = elem.id
                        }
                    })
            }else{
                //find the lesson_id from the list
                this.lesson_list.forEach((elem, index)=>{
                    if(elem.id == this.modal_lesson.id){
                        this.current_lesson_delete_id = elem.id
                        lesson_index = index
                        this.temp_language = this.selected_language

                    }
                })
            }
            this.$store.dispatch('removeTincan', { id : this.current_lesson_delete_id, key:this.temp_language.key }).then((res) => {

                this.lesson_list[lesson_index].image[this.temp_language.key] = null
                this.lesson_list[lesson_index].has_tincan[this.temp_language.key] = res.data.lesson.has_tincan[this.temp_language.key];
                this.lesson_list[lesson_index].tincan_url[this.temp_language.key] = null
                this.lesson_list[lesson_index].tincan_download_url[this.temp_language.key] = null
                this.lesson_list[lesson_index].tincan_thumbnail[this.temp_language.key] = null

                if(this.current_lesson_modal !=null){
                    this.curren_lesson_show = this.lesson_list[lesson_index]
                }
                this.closeModal();

            }).catch((error) => {
                console.log(error);
            })
        },
        dropzoneFail: function(_file, _message, xhr){
            const elements = document.querySelectorAll('.dz-error-message span')
            const lastElement = elements[elements.length - 1]
            lastElement.textContent = "Server Error."

        },
        updateLessonTincan(lesson, index){
            this.lesson_list[index] = lesson

        },
        chooseLessonFileType(lesson){
            console.log(lesson)
            var temp_lesson = lesson
            temp_lesson.lesson_filetype_id = lesson.filetype.id
            // this.current_lesson_modal.lesson_filetype_id = this.lesson_file_type.id

            this.$store.dispatch('editLesson', temp_lesson).then((res) => {
                console.log(res)
            }).catch((error) => {
                this.$snotify.error('Error from server');
            });

            console.log(lesson)
        }
    }
}
</script>
<style scoped>
.lesson-order-frame{
    background-color: #11A5A7;
    font-size: 18px;
    font-weight: bold;
    padding: 0px 8px;
    border-radius: 26px;
    position: relative;
    top: 0px;
    left: -16px;
}
.edit-time{
    max-width: 39px;
    padding-bottom: 2px;
    border-top: hidden;
    border-left: hidden;
    border-right: hidden
    
}
.input-content .input-course-title {
    font-size: 1.6em;
}
.input-content .input-lesson-title {
    font-size: 1.8em;
}
.deneme{
    background-color:#f5f5f5;
    min-height: 100px !important;
}
.lesson-border{
    background-color:#f5f5f5;
    border-radius: 14px;
}
.white-background{
    background-color:white !important;
}
.general-border{
    border: 5px solid white;
    border-radius: 8px;
}
.white-background{
    background-color:#fff !important;
}
.put_content_right{
    margin-left:auto;
}
.desciption-width{
    min-width: 350px;
}
.lesson_title{
    min-height: 100px !important;
}
.lesson_title_tall{
    min-height: 130px !important;
}
.image-holder{
    max-width: 200px;
    max-height: 120px;
}
.image-holder-empty{
    max-width: 200px;
    max-height: 120px;
    min-width: 200px;
    min-height: 120px;
}

</style>



// WEBPACK FOOTER //
// src/components/sme/SharedViews/ProgramLessonView.vue